import { render, staticRenderFns } from "./scratch-card.vue?vue&type=template&id=7eec35a4&scoped=true&"
import script from "./scratch-card.vue?vue&type=script&lang=js&"
export * from "./scratch-card.vue?vue&type=script&lang=js&"
import style0 from "./scratch-card.vue?vue&type=style&index=0&id=7eec35a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eec35a4",
  null
  
)

export default component.exports